import Link from '../Link';

type ContextBlockContentProps = {
  showTitle: boolean;
  title: string;
  content: string;
  linkTitle: string;
  linkURL: string;
}

const ContextBlockContent: React.FC<ContextBlockContentProps> = ({
  showTitle,
  title,
  content,
  linkTitle,
  linkURL
}) => {
  return (
    <>
      {showTitle && (
        <h2 className="context-block__heading">{title}</h2>
      )}
      {content && (
        <div className="context-block__content">
          <p dangerouslySetInnerHTML={{ __html: content }}/>
          {linkURL && (
            <div className="context-block__button-wrapper">
              <Link
                title={linkTitle}
                link={linkURL}
                extraClass="context-block__button"
                arrowFill="currentColor"
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ContextBlockContent;

